import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "type", "xs", "sm", "md", "lg", "offset", "gutter", "nowrap", "totalCols", "debug", "ignoreKeyboardDebug", "className", "htmlProps"];
import { useMemo } from 'react';
import cn from 'classnames';
import styled from 'styled-components';
import getResponsiveStyled from "../helpers/getResponsiveStyledDefault";
import useDebug from "../useDebug";
import getPaddingClass from "./helpers/getPaddingClass";
import { DASHBOARD_GUTTER, DEFAULT_GUTTER } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledCol = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-jey6np-0"
})(["\n  ", "\n"], function (props) {
  return getResponsiveStyled(props);
});
var Col = function Col(_ref) {
  var children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    _ref$xs = _ref.xs,
    xs = _ref$xs === void 0 ? 12 : _ref$xs,
    smProp = _ref.sm,
    mdProp = _ref.md,
    lgProp = _ref.lg,
    offset = _ref.offset,
    gutterProp = _ref.gutter,
    nowrap = _ref.nowrap,
    _ref$totalCols = _ref.totalCols,
    totalCols = _ref$totalCols === void 0 ? 12 : _ref$totalCols,
    debugProp = _ref.debug,
    ignoreKeyboardDebug = _ref.ignoreKeyboardDebug,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    colProps = _objectWithoutProperties(_ref, _excluded);
  var debug = useDebug(debugProp, ignoreKeyboardDebug);
  var isDashboard = type === 'dashboard';
  var defaultGutter = isDashboard ? DASHBOARD_GUTTER : DEFAULT_GUTTER;
  var gutter = gutterProp || defaultGutter;
  var gutterClasses = useMemo(function () {
    if (!gutter) {
      return '';
    }
    if (typeof gutter === 'number') {
      return getPaddingClass(gutter, className, nowrap);
    }
    var mobile = typeof gutter.xs === 'number' ? gutter.xs : 8;
    var sm = typeof gutter.sm === 'number' ? gutter.sm : mobile;
    var md = typeof gutter.md === 'number' ? gutter.md : sm;
    var lg = typeof gutter.lg === 'number' ? gutter.lg : md;
    var classes = getPaddingClass(mobile, className, nowrap);
    if (sm !== xs) {
      classes = classes.concat(" ".concat(getPaddingClass(sm, className, nowrap, 'sm')));
    }
    if (md !== sm) {
      classes = classes.concat(" ".concat(getPaddingClass(md, className, nowrap, 'md')));
    }
    if (lg !== md) {
      classes = classes.concat(" ".concat(getPaddingClass(lg, className, nowrap, 'lg')));
    }
    return classes;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gutter]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    _jsx(StyledCol, _objectSpread(_objectSpread(_objectSpread({
      className: cn(gutterClasses, {
        'border border-solid border-purple-light': debug
      }, className),
      totalCols: totalCols,
      xs: xs,
      sm: smProp,
      md: mdProp,
      lg: lgProp,
      offset: offset
    }, colProps), htmlProps), {}, {
      children: children
    }))
  );
};
export default Col;